/**
 * @file store 文件
 * @author fengfaxia(fengfaxia@baidu.com))
 *  Copyright (c) 2018-10-24 Baidu
 */
import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import reducers from '../reducers/reducers';

let store = {};
if (process.env.NODE_ENV !== 'production') {
    store = compose(applyMiddleware(thunk, logger))(createStore)(reducers);
}
else {
    store = compose(applyMiddleware(thunk))(createStore)(reducers);
}
export default store;
